"use strict";

import {preloadSlide} from "@elements/slider";
import {onEnterViewPort} from "@elements/viewport-utils";

let sliderId = 0;

export function initInScope($scope) {

    let $thumbSlider = $scope.find('.js-gallery-slider');

    if (!$thumbSlider.length) {
        return;
    }

    import('slick-carousel').then(function () {
        $thumbSlider.each(function () {
            let $container = $(this);
            let $mainSlider = $container.find('.js-gallery-slider__main');

            $mainSlider.on('afterChange', function (event, slick, currentSlide) {
                preloadSlide(slick, currentSlide + (matchMedia('(max-width: 767px)').matches ? 2: 1));

                /* set active Nr */
                let currentSlideInt = Math.min(parseInt(currentSlide + 1));
                $mainSlider.closest('.js-gallery-slider').find('.js-gallery-slider__current').html(currentSlideInt);

            }).slick({
                dots: true,
                prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><span class='icon icon-arrow-left'></span></button>",
                nextArrow:"<button type='button' class='slick-next' aria-label='next'><span class='icon icon-arrow-right'></span></button>",
                infinite: false
            }).each(function () {
                let $slider = $(this);
                onEnterViewPort($slider, function () {
                    preloadSlide(
                        $slider.slick('getSlick'),
                        (matchMedia('(max-width: 767px)').matches ? 2: 1)
                    );
                });
            });

        });
    });
}